export default __webpack_public_path__ + "images/maps-marker.07e5cbb9e28c5c9032f86239489fcac7.png";